<script setup>
import DownCaretIcon from '@/js/core/components/icons/DownCaretIcon.vue';
import TrayUserSelector from '@/js/core/components/parts/trays/TrayUserSelector.vue';
import { MANAGER_ACCESS_OPTIONS } from '@/js/core/constants/tray-constants';

defineProps({
  managerAccess: {
    type: String,
    required: true,
  },
  managerUsers: {
    type: Array,
    required: true,
  },
  excludedUuids: {
    type: Array,
    default: () => [],
  },
  error: {
    type: String,
    default: '',
  },
  idPrefix: {
    type: String,
    default: 'tray',
  },
});

defineEmits(['update:managerAccess', 'update:managerUsers']);
</script>

<template>
  <div class="tray-form__group tray-access-group">
    <label :for="`${idPrefix}-managers-access`" class="tray-form__label">
      Who can edit this Tray?<span class="tray-form__required">*</span>
    </label>
    <div class="tray-form__select-wrapper">
      <select
        :id="`${idPrefix}-managers-access`"
        :value="managerAccess"
        class="tray-form__select"
        required
        @change="$emit('update:managerAccess', $event.target.value)"
      >
        <option v-for="option in MANAGER_ACCESS_OPTIONS" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>
      </select>
      <DownCaretIcon class="tray-form__select-icon" />
    </div>
    <TrayUserSelector
      v-if="managerAccess === 'specific'"
      :model-value="managerUsers"
      :input-id="`${idPrefix}-managers`"
      search-label="Add someone who can edit this Tray"
      :excluded-uuids="excludedUuids"
      :error="error"
      @update:model-value="$emit('update:managerUsers', $event)"
    />
  </div>
</template>
